import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { CompanyFormValues, companySchema } from "@modules/companies/validations/companySchema";
import { useEditCompanyMutation } from "@modules/companies/services/mutations";

export function useCompanyEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditCompanyMutation(id as string);

  const methods = useForm<CompanyFormValues>({
    resolver: zodResolver(companySchema()),
    defaultValues: {
      rank: 0,
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
